export const DETAIL_LAYOUTS = [
  'bulletin',
  'detailCard',
  'grid',
  'keyValue',
  'modalGrid',
  'scale'
] as const
